import { DragInstance } from './DragInstance';
import { IDropTarget } from './IDropTarget';

class DropResult {
  public drag: DragInstance;
  public target: IDropTarget | null;
  public dropAccepted: boolean;
  public canceled: boolean;
  public isCopyDrop: boolean;
  public constructor(
    drag: DragInstance,
    target: IDropTarget | null,
    dropAccepted: boolean,
    canceled: boolean,
    isCopyDrop: boolean) {
    this.drag = drag;
    this.target = target;
    this.dropAccepted = dropAccepted;
    this.canceled = canceled;
    this.isCopyDrop = isCopyDrop;
  }
}

export { DropResult };
